/**
 * ナビゲーションアイテムを格納するインターフェース
 */
interface NaviItems {
  /** ナビゲーションアイテム */
  [key: string]: NaviItem;
}

/**
 * ナビゲーションアイテムのインターフェース
 */
export interface NaviItem {
  /** アイテムの一意のID */
  id: number;
  /** アイテムのラベル */
  label: string;
}

/**
 * アコーディオン項目の定数
 */
export const ACCORDION_ITEMS: NaviItems = {
  historyJobs: {
    id: 1,
    label: '最近見た求人',
  },
  searchedConditions: {
    id: 2,
    label: '最近検索した条件',
  },
  bookmarkList: {
    id: 3,
    label: '気になるリスト',
  },
  savedSearches: {
    id: 4,
    label: '保存した検索条件',
  },
} as const;

/**
 * 最大取得件数の定数
 */
export const MAX_COUNT = 10;
